import { render, staticRenderFns } from "./NumberFilter.vue?vue&type=template&id=48f2270c&"
import script from "./NumberFilter.vue?vue&type=script&lang=js&"
export * from "./NumberFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports